export default __webpack_public_path__ + "static/media/debts.a2aacf39.png";